import { HTMLFromRichText, PrismicLink, PrismicSharpImage, TextFromRichText } from './PrismicTypes';

export const GENERIC_HERO_IMAGE = 'PrismicGenericTemplateDataBodyHeroImage';

export const GENERIC_HERO_BUTTON = 'button';
export const GENERIC_HERO_REASON = 'reason';

export interface GenericHeroImagePrimary {
  alignment?: 'center' | 'left';
  background_color?: 'string';
  hero_image_disclaimer?: TextFromRichText;
  hero_component_image?: PrismicSharpImage;
  hero_image_subtitle: HTMLFromRichText;
  hero_image_title: TextFromRichText;
  hide_breadcrumbs?: boolean;
  primary_button: TextFromRichText;
  primary_button_link: PrismicLink;
  hero_component_image_mobile?: PrismicSharpImage;
  secondary_button: TextFromRichText;
  component_type: 'Default' | 'HeroBanner';
  secondary_button_link: PrismicLink;
  lendi_logo_variant: 'light' | 'dark';
  partner_logo?: PrismicSharpImage;
  partner_logo_height?: number;
}

export interface GenericHeroComponentField {
  component_icon: string;
  component_text: TextFromRichText;
}

export interface GenericHeroComponentButton extends GenericHeroComponentField {
  button_link: PrismicLink;
  additional_component_type: typeof GENERIC_HERO_BUTTON;
}

export interface GenericHeroComponentReason extends GenericHeroComponentField {
  visible_on_mobile: boolean;
  additional_component_type: typeof GENERIC_HERO_REASON;
}

export interface GenericHeroImageContent {
  __typename: typeof GENERIC_HERO_IMAGE;
  primary: GenericHeroImagePrimary;
  items: (GenericHeroComponentButton | GenericHeroComponentReason)[];
}
